// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3Cw9V","colMin":"styles_colMin__EGHQr","colCheckbox":"styles_colCheckbox__1x7T0"};